import ChatPage from "./ChatPage";

function App() {
  return <ChatPage />;
}

export default App;